import { capitalCase } from 'change-case'
import { useState, useEffect, useRef, useCallback, forwardRef } from 'react'
import {
  Groups,
  CheckCircle,
  Error,
  Attachment,
  MoreVert,
  Print,
  List,
  ViewList,
  ViewModule,
  UploadFileSharp,
} from '@material-ui/icons'
import Tooltip from '@mui/material/Tooltip'
// material
import {
  Container,
  Tab,
  Box,
  Tabs,
  Stack,
  Button,
  Menu,
  Typography,
  MenuItem,
  TextField,
  Card,
  Grid,
  Slider as Sliderw,
  ListItemText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardContent,
  ImageList,
  useMediaQuery,
  ImageListItem,
  ImageListItemBar,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  IconButton,
  Backdrop,
} from '@material-ui/core'
import {
  alpha,
  experimentalStyled as styled,
  useTheme,
} from '@material-ui/core/styles'
// components
import Tasks from '../../components/projects/viewProjects/Tasks'
import Members from '../../components/projects/viewProjects/Members'
import ViewRequest from 'src/components/_dashboard/official-request/ViewRequest'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs'
import axios from 'axios'
import { COMPANY_NAME, REST_API_END_POINT, REST_API_IO } from 'src/constants/Defaultvalues'
import { useParams, useNavigate, useLocation } from 'react-router'
// import { io } from 'socket.io-client' // OLD
import createAppSocket from 'src/Helpers/createSocket'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import Label from 'src/components/Label'
import Scrollbar from 'src/components/Scrollbar'
import moment from 'moment'
import AddTask from 'src/components/projects/AddTask'
import AddMember from 'src/components/projects/AddMember'
import AddProject from 'src/components/_dashboard/blog/AddProject'
import { useSnackbar } from 'notistack'
import ReactToPrint from 'react-to-print'
import { KeyboardBackspaceOutlined } from '@material-ui/icons'
import { Link as RouterLink } from 'react-router-dom'
import { PATH_DASHBOARD, ROOTS_PCB } from '../../routes/paths'
import { CarouselControlsPaging1 } from '../../components/carousel'
import Slider from 'react-slick'
import { LoadingButton } from '@material-ui/lab'
import { storage } from 'src/firebase/firebase'
import {
  deleteObject,
  getDownloadURL,
  uploadBytesResumable,
  ref as imageref,
} from '@firebase/storage'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import ProjectAttachment from 'src/components/_dashboard/blog/ProjectAttachment'
import { set } from 'lodash'
import Locations from 'src/components/_dashboard/official-request/Locations'
import ConfirmationPopup from 'src/components/confirmationPopup'
import LoadingScreen from 'src/components/LoadingScreen'
import JobNotesMessageBoard from 'src/components/_dashboard/user/profile/JobNotesMessageBoard'
import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow'
import { SalesOrderNewBadgeList } from 'src/components/_dashboard/official-request/SalesOrderNewBadge'
import useJobNoteTabUnread from 'src/hooks/useJobNoteTabUnread'
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import EstimateTask from 'src/components/projects/viewProjects/EstimateTask'
import { UploadMultiFile } from 'src/components/upload'
import { supabase } from 'src/supabase/supabaseClient'
import { Slide } from '@mui/material'

const ClockInTransition = forwardRef(function ClockInTransition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

// ----------------------------------------------------------------------

let option = [
  { id: 1, value: 'New' },
  { id: 2, value: 'Inprogress' },
  { id: 3, value: 'Completed' },
  { id: 4, value: 'Rejected' }, 
]
const colors = [
  '#c9302c',
  '#5bc0de',
  '#0275d8',
  '#008000',
  '#f0ad4e',
  '#5cb85c',
  '#c9302c',
  '#5cb85c',
  '#5bc0de',
]

const PRODUCTS = [
  { name: 'Air Max 97', image: `/static/mock-images/products/product_1.jpg` },
  { name: 'PierBurger', image: `/static/mock-images/products/product_2.jpg` },
  {
    name: 'BLACK LIVE MATTERS',
    image: `/static/mock-images/products/product_3.jpg`,
  },
  { name: 'Britex', image: `/static/mock-images/products/product_4.jpg` },
  {
    name: 'KEG Steak House Bar',
    image: `/static/mock-images/products/product_5.jpg`,
  },
]

const CarouselImgStyle = styled('img')(({ theme }) => ({
  width: '100%',
  height: 280,
  objectFit: 'cover',
  [theme.breakpoints.up('xl')]: {
    height: 320,
  },
}))

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

const CustomTab = styled(Tab)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  boxShadow: 'none', //theme.shadows[5],
  minHeight: 'fit-content',
  indicator: {
    display: 'none',
  },
  height: 38,
  fontSize: 12,
  borderRadius: 'none', //20
  border: '1.5px solid #00c2ff', //newlyadded
  background: '#161c24',
  margin: 0, //5
  color: theme.palette.text.primary,
  '&:hover': {
    background: '#161c24',
  },
  '&.Mui-selected': {
    background: theme.palette.primary.main,
    color: '#fff',
  },
  '&:first-child': {
    borderRadius: '7px 0 0 7px',
    borderLeft: `1.5px solid ${theme.palette.primary.main}`,
  },
  '&:nth-child(2)': {
    borderRadius: '0',
    borderLeft: '0',
  },
  '&:nth-child(3)': {
    borderRadius: '0',
    borderLeft: '0',
  },
  '&:last-child': {
    borderRadius: '0 7px 7px 0',
    borderLeft: '0',
  },

  [theme.breakpoints.up('lg')]: {
    marginRight: `0 !important`,
    minWidth: '20% !important',
  },
  [theme.breakpoints.down('lg')]: {
    marginRight: `0 !important`,
    minWidth: '20% !important',
  },
  [theme.breakpoints.down('sm')]: {
    marginRight: `0 !important`,
    minWidth: '30.33% !important',
  },
}))

const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { color: 'warning', label: 'Status: Draft' }
    case 2:
      return { color: 'info', label: 'Status: Open' }
    case 3:
      return { color: 'primary', label: 'Status: Evaluating' }
    case 4:
      return { color: 'success', label: 'Status: Accepted' }
    case 5:
      return { color: 'warning', label: 'Status: Closed' }
    case 6:
      return { color: 'error', label: 'Status: Rejected' }
    default:
      return { color: 'default', label: 'Status: Open' }
  }
}
const getFileType = (fileType) => {
  if (fileType.startsWith('image/')) {
    return 'image'
  } else if (fileType.startsWith('video/')) {
    return 'video'
  } else {
    return 'other'
  }
}
export default function ViewEstimateProject({idOfProject,setProjectsId,popupOn,closeView,handleClickOpenRecipeCost,setRecipeCostId,setRecipeCostCurrentTab,setRenderCardsMain,setPostId,handleinnerTask,setTaskCurrentTab,setTaskdetails,onDataChange,fromCalender}) {
  const theme = useTheme()
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const { enqueueSnackbar } = useSnackbar()
  const ref = useRef(null)
  const componentRef = useRef()
  const navigate = useNavigate()
  const { id:ids } = useParams()
  const id = popupOn ? idOfProject : ids
  const fileInputRef = useRef()
  const [progress, setProgress] = useState(false)
  const user = JSON.parse(window.localStorage.getItem('user'))
  const explodedPermissions = user?.exploded_permissions
  const [isOpen, setIsOpen] = useState(false)
  const [secTab, setSecTab] = useState('Tasks')
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [add, setAdd] = useState(false)
  const [addMember, setAddMember] = useState(false)
  const [selected, setSelected] = useState([])
  const [data, setData] = useState(null)
  console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaaa', data)
  const [projectMembers, setProjectMembers] = useState(null)
  const [projectTask, setProjectTask] = useState(null)
  const [allTeamMembers, setAllTeamMembers] = useState(null)
  const[collaborators, setCollaborators] = useState(null)
  const [onlineUsers, setOnlineUsers] = useState([])
  const socketRef = useRef(null)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [details, setDetails] = useState(null)
  console.log('detailsdetailsdetailsdetails',details)
  const [requestServices, setRequestServices] = useState([])
  const [rfpServices, setRfpServices] = useState([])
  const [customerData, setCustomerData] = useState(null)
  const [designs, setDesigns] = useState([])
  const [invoice, setInvoice] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [renderCards, setRenderCards] = useState(false)
  const [fetchData, setFetchData] = useState(false)
  const [singleProjectData, setSingleProjectData] = useState(null)
  const [openAttachModal, setOpenAttachModal] = useState(false)
  const [attachments, setAttachments] = useState({})
  const [valueTab, setValueTab] = useState('one')
  const [refresh, setRefresh] = useState(false)
  const [signAgreements, setSignAgreements] = useState(null)
  const [portfolio, setPortfolio] = useState(null)
  const [customTemplate, setCustomTemplate] = useState(null)
  const [questionnaireTemplate, setQuestionnaireTemplate] = useState(null)
  const [allDataEmpty, setDataEmpty] = useState(true)
  const [proposalData, setProposalData] = useState(null)
  const [component, setComponent] = useState(null)
  const [clientId,setClientId] = useState(null)
  const [openPopup, setOpenPopup] = useState(false)
  const [openPopupComplete, setOpenPopupComplete] = useState(false)
  const [openHoldPopup, setOpenHoldPopup] = useState(false)
  const [openSubtaskValidationPopup, setOpenSubtaskValidationPopup] = useState(false)
  const [openServiceWorkflowConfirmation, setOpenServiceWorkflowConfirmation] = useState(false)
  const [openService, setOpenService] = useState(false)
  const [subTaskMembers, setSubTaskMembers] = useState([])
  const [clockInInputs, setClockInInputs] = useState([])
  const [pendingStatusUpdate, setPendingStatusUpdate] = useState(null)
  const [clockInLoading, setClockInLoading] = useState(false)
  const userId = user?.user_id
  const [selectedOption, setSelectedOption] = useState(null)
  const [holdReason, setHoldReason] = useState('')
  const [isSubmittingHold, setIsSubmittingHold] = useState(false)
  const [holdReasonError, setHoldReasonError] = useState('')
  const [openRejectPopup, setOpenRejectPopup] = useState(false)
  const [rejectReason, setRejectReason] = useState('')
  const [rejectFiles, setRejectFiles] = useState([])
  const [isSubmittingReject, setIsSubmittingReject] = useState(false)
  const [isUploadingRejectFile, setIsUploadingRejectFile] = useState(false)
  const [isSubmittingRestore, setIsSubmittingRestore] = useState(false)
  const [status, setStatus] = useState(null)
  const [completeStatus, setCompleteStatus] = useState(1)
  const [loading, setLoading] = useState(false)
  const [designersList, setDesignersList] = useState([])
  const [loadingJobCost, setLoadingJobCost] = useState(true)
  const [installationCompleted,setAllInstallationCompleted] = useState(null)
  const [jobNoteMembers, setJobNoteMembers] = useState(null)
  const [isMember, setIsMember] = useState(false);
  const [updates, setUpdates] = useState(null)
  const [options, setOptions] = useState([
    { id: 1, value: 'New' },
    { id: 2, value: 'Inprogress' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Rejected' }, 
  ])
  const location = useLocation()
  let currentTab = location?.state?.currentTab
  const isFromCommunityJob = location.state?.fromCommunityJob || false;
  const isFromEstimateLogs = location.state?.fromEstimateLogs || false;
  const estimateBackTo = isFromEstimateLogs
    ? PATH_DASHBOARD.quotation.logs
    : PATH_DASHBOARD.quotation.job;
  const userType = user?.user_type;
  const {
    hasNew: jobNotesHasNew,
    clearNew: clearJobNotesNew,
  } = useJobNoteTabUnread({
    requestId: details?.id || null,
    designOrderId: details?.design_order_id || null,
    noteType: 'job',
    userId: user?.user_id,
    enabled: userType !== 3 && !!details?.id,
    isActiveTab: secTab === 'Job Notes',
    activeTab: secTab,
  })
  console.log('############location view project', currentTab)
  const handleChange = (event, newValue) => {
    setValueTab(newValue)
  }
  const hasJobPermission = explodedPermissions?.some((permission) =>
    ['Update Estimate Job Status'].includes(permission),
  )
    ? true
    : false
  const estimateJobStatusUnlocked =
    Number(details?.quotation_status) === 3 ||
    (Number(details?.is_request_estimate) === 1 &&
      Number(details?.is_create_estimate) === 1)
  const hasHoldEstimateJobsPermission = explodedPermissions?.some((permission) =>
    ['Hold Estimate Jobs'].includes(permission),
  )
    ? true
    : false
  const hasEstimateJobCostPermission = explodedPermissions?.some((permission) =>
    ['Manage Estimate Job Cost'].includes(permission),
  )
    ? true
    : false
  const hasViewCostPermission = explodedPermissions?.some((permission) =>
    ['View Estimate Cost'].includes(permission),
  )
    ? true
    : false
  const hasAddTaskEstimateJobPermission = explodedPermissions?.some((permission) =>
    ['Add Task to Estimate Job'].includes(permission),
  )
    ? true
    : false
  const hasAddMemberEstimateJobPermission = explodedPermissions?.some((permission) =>
    ['Add Member to Estimate Job'].includes(permission),
  )
    ? true
    : false
  const canViewEstimateJobAttachments =
    user?.user_type === 3 ||
    explodedPermissions?.some((permission) =>
      ['View Estimate Job Attachments', 'Manage Estimate Job Attachments'].includes(permission),
    )
      ? true
      : false
  const canManageEstimateJobAttachments =
    user?.user_type !== 3 &&
    explodedPermissions?.some((permission) =>
      ['Manage Estimate Job Attachments'].includes(permission),
    )
      ? true
      : false
  const canHoldEstimateJob = user?.user_type !== 3 && hasHoldEstimateJobsPermission
  const isEstimateVoided = Number(details?.quotation_status) === 12
  const isJobRejected = data?.is_rejected === 1 || data?.is_rejected === '1'
  const isEstimateDraft =
    details?.is_draft === 1 ||
    details?.is_draft === '1' ||
    data?.is_draft === 1 ||
    data?.is_draft === '1' ||
    details?.quotation_status === 4 ||
    (details?.quotation_status === 1 &&
      (details?.is_draft === 1 || details?.is_draft === '1'))
  const canViewEstimateJobCost = user?.user_type !== 3 && hasEstimateJobCostPermission
  const canAddEstimateJobTask = user?.user_type !== 3 && hasAddTaskEstimateJobPermission
  const canAddEstimateJobMember = user?.user_type !== 3 && hasAddMemberEstimateJobPermission
  const canViewEstimateDetails =
    user?.user_type === 3 ||
    explodedPermissions?.some((permission) =>
      ['View Estimate', 'View Estimate Job as Admin'].includes(permission),
    )
  useEffect(() => {
    if (secTab === 'Attachments' && !canViewEstimateJobAttachments) {
      setSecTab('Tasks')
    }
  }, [secTab, canViewEstimateJobAttachments])
  const handleback = () => {
    window.history.back()
  }

  const [data1, setData1] = useState({})
  const fetchDetails = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}settings/get-companyProfile-details`,
      )
      if (res.data.status === 1) {
        setData1(...res.data.data)
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error)
    }
  }

  useEffect(() => {
    fetchDetails()
  }, [])

    useEffect(() => {
    if (details?.project_category == 12 && projectTask?.length <= 0) {
      setOptions((prev)=>prev?.filter((item)=>item.id !== 2))
    } else {
      // Reset to original options when conditions are not met
      setOptions([
        { id: 1, value: 'New' },
        { id: 2, value: 'Inprogress' },
        { id: 3, value: 'Completed' },
        { id: 4, value: 'Rejected' }, 
      ])
    }
  }, [details,projectTask])
  // const handleJobsTabCount = async () => {
  //   try {
  //     const response = await axios.post(`${REST_API_END_POINT}jobs/reduce-tabs-count`, {
  //       userId:user.user_id,
  //       project_id:id,
  //     });
      
  //   } catch (error) {
  //     console.error("Error reducing estimate count:", error);
  //   }
  // };

  // useEffect(() => {
  //   handleJobsTabCount()
  // }, [])

  const settings = {
    speed: 1000,
    dots: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    ...CarouselControlsPaging1({ color: 'primary.main' }),
  }

  console.log('holdcheck==currentTab==',currentTab)
  console.log('holdcheck==details==',details)
  console.log('holdcheck==data==',data)

  useEffect(() => {
    if (Array.isArray(jobNoteMembers) && user?.user_id) {
      const found = jobNoteMembers?.some(member => member.user_id === user.user_id);
      setIsMember(found);
    }
  }, [jobNoteMembers, user?.user_id]);

  console.log('isMemberisMember', isMember)
  

  const TABS = [
    {
      value: 'Members',
      component: (
        <Members
          setFetchData={setFetchData}
          data={projectMembers}
          currentTab={currentTab}
          projectData={data}
          isEstimateJob={true}
          details={details}
        />
      ),
    },
    {
      value: 'Tasks',
      component: (
        <EstimateTask
          isEstimateJob={true}
          isTimeAndMaterial={details?.project_category === 12}
          setTaskdetails={setTaskdetails}
          setTaskCurrentTab={setTaskCurrentTab}
          setPostId={setPostId}
          popupOn={popupOn}
          setProjectsId={setProjectsId}
          details={data}
          quotationStatus={details?.quotation_status}
          designs={designs}
          valueTab={valueTab}
          setFetchData={setFetchData}
          data={projectTask}
          projectId={id}
          refresh={refresh}
          setRefresh={setRefresh}
          currentTab={currentTab}
          handleinnerTask={()=>handleinnerTask()}
          onDataChange={onDataChange}
          projectMembers={projectMembers}
          subtaskcount={projectTask?.reduce((total, task) => total + (task.subtask_count || 0), 0) || 0}
        />
      ),
    },
    ...(canViewEstimateJobAttachments
      ? [
          {
            value: 'Attachments',
            component: (
              <ProjectAttachment
                projectId={id}
                currentTab={currentTab}
                data={data}
                installationCompleted={installationCompleted}
                canManage={canManageEstimateJobAttachments}
              />
            ),
          },
        ]
      : []),
    {
      value: `Order Details`,
      component: details ? (
        <ViewRequest
          products={invoice?.cust_product}
          teamMembers={projectMembers}
          user={user}
          designs={designs}
          setDesigns={setDesigns}
          details={details}
          isEstimate={true}
          quotation={1}
          requestId={id}
          signAgreements={signAgreements}
          customTemplate={customTemplate}
          questionnaireTemplate={questionnaireTemplate}
          allDataEmpty={allDataEmpty}
          portfolio={portfolio}
          project={true}
          clientDetails={customerData}
          designersList={designersList}
          allTeamMembers={allTeamMembers}
          collaboratorsTeamMembers={collaborators}
          onlineUsers={onlineUsers}
          estimateJobRejection={{
            is_rejected: data?.is_rejected,
            rejection_reason: data?.rejection_reason,
            rejection_file: data?.rejection_file,
            rejected_at: data?.rejected_at,
            rejected_by_name: data?.rejected_by_name,
          }}
          // invoice={invoice}
        />
      ) : (
        ''
      ),
    },
    {
      value: 'Job Log',
      component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} details={details} searchable onSearchUpdates={handleJobLogSearch}/>,
    },
    {
      value: 'Job Notes',
      component: (
        <Card sx={{ display: 'flex', minHeight: 400, maxHeight: '490px', height: '72vh' }}>
          <JobNoteWindow
            products={invoice?.cust_product}
            allUser={jobNoteMembers}
            requestIdd={details?.id}
            designOrderId={details?.design_order_id || null}
            requestDetails={details}
            fromDesign={false}
            isDesignOrder={false}
            renderCards={renderCards}
            setRenderCards={setRenderCards}
            details={details}
            noteType="job"
          />
        </Card>
      ),
    }
  ]
const handleClickforProject=(id,currentTab)=>{
  setRecipeCostCurrentTab(currentTab)
  setRecipeCostId(id)
  handleClickOpenRecipeCost()
}


console.log('detailsdetailsdetailsdetails',details)
  useEffect(() => {
    try {
      localStorage.setItem('params', '')
      const hasPermission = explodedPermissions?.some((permission) =>
        [
          'View Estimate Jobs',
          'Hold Estimate Jobs',
          'Manage Estimate Job Cost',
        ].includes(permission),
      )
        ? true
        : false
      setLoading(true)
      axios
        .post(
          `${REST_API_END_POINT}project/get-project-by-id`,
          {
            id: { value: id },
            userId: user.user_id,
            userType: user.user_type,
            hasPermission,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          setSingleProjectData(response.data)
          setValue(
            options?.find((opt) => response.data.result.status === opt.id),
          )
          fetchRequestDetails(response.data.result.request_id)
          setClientId(response.data?.result?.customer_id)
          setData(response.data.result)
          setProjectMembers(response.data.projectMembers)
          setProjectTask(
            response?.data?.projectTask?.filter(task => task.service_type === 44 || task.is_manually_added === 1)
          );
          setAllTeamMembers(response.data.teamMembers)
          setFetchData(false)
          setRefresh(false)
          setTimeout(() => {
            setLoading(false)
          }, 1000)
        })
        .catch((error) => {
          console.error(error)
        })

      // handleFetchEditData(id)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }, [isEdit, fetchData, refresh, id])

  const fetchTimeLogData = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}project-task/fetch-clockedIn-staff-task-timelog`,
        { projectId: Number(id), taskId: null, userId: user.user_id, },
      )
      if (res.data.status === 1) {
        const staffTimeLogData = res.data.result[0];
        if (staffTimeLogData.end_time === null) {
          setIsLoggedIn(true)
        } else {
          setIsLoggedIn(false)
        }
      } else {
        setIsLoggedIn(false)
      }
    } catch (error) {
      console.log('Error fetching : ', error)
    }
  }

  useEffect(()=>{
    if(id){
      fetchTimeLogData()
    }
  },[id])

  useEffect(() => {
    if (!socketRef.current) {
      // OLD CODE (keep for future restore):
      // socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: ["websocket", "polling"], secure: true });
      socketRef.current = createAppSocket();
    }
    if (user?.user_id && socketRef.current && id) {
      socketRef.current.emit("request-online-user", { userId: user.user_id, requestId: id });
      socketRef.current.emit("get-request-online-users", { requestId: id });
    }
    if (socketRef.current) {
      socketRef.current.on("update-request-online-users", (payload) => {
        if (!payload) return;
        const { requestId, users } = payload;
        if (String(requestId) !== String(id)) return;
        setOnlineUsers((users || []).map(String));
      });
    }
    return () => {
      if (socketRef.current && user?.user_id && id) {
        socketRef.current.emit("leave-request", { userId: user.user_id, requestId: id });
      }
      if (socketRef.current) socketRef.current.off("update-request-online-users");
    };
  }, [user?.user_id, id]);

  const fetchTeamMembersForCollaborators = async () => {
    if (!user?.user_id) return;
    try {
      const isClient = user?.isClient || false;
      const userType = isClient ? 3 : user.user_type;
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: user.user_id,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setTeamMembersOptions(filteredList);
      setCollaborators(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
    }
  };

  // Fetch team members on mount
  useEffect(() => {
    if (user?.user_id) {
      fetchTeamMembersForCollaborators();
    }
  }, []);


  const fetchRequestDetails = async (request_id) => {
    setLoading(true)
    try {
      console.log({ request_id })
      const res = await axios.post(`${REST_API_END_POINT}view-request-production-inner-page`, {
        request_id,
        userId: user.user_id,
        userType: user.user_type,
      })
      res.data

      setDetails(res.data?.data[0])

      setAllInstallationCompleted(res.data?.data[0]?.allInstallationCompleted)
     
      setSecTab('Tasks')

      console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaaa', res.data?.data[0])

      fetchOrderProductDetails(res.data.data[0]?.id)

      setRefresh(false)
      setProposalData(res.data.requestProposals)
    } catch (error) {
      console.error('Error fetching request details:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchRequestAttachments = async (request_id) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-attachments`,
        {
          request_id,
        }
      )
      if (res.data.status === 1) {
        setDesigns(res.data.attachments)
      }
    } catch (error) {
      console.error('Error fetching attachments:', error)
    }
  }

  const fetchRequestUpdates = async (request_id, search = '') => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-updates`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,
          search,
        }
      )
      if (res.data.status === 1) {
        if (!search) {
          setUpdates(res.data.updates)
        }
        return res.data.updates || []
      }
    } catch (error) {
      console.error('Error fetching updates:', error)
      if (search) return []
    }
  }

  // `RequestTabUpdates` handles debouncing internally.
  async function handleJobLogSearch(search) {
    if (!details?.id) return []
    return fetchRequestUpdates(details.id, search)
  }

  const fetchRequestServices = async (request_id) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-services`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,
        }
      )
      if (res.data.status === 1) {
        const allServices = res.data.requestServices || []
        setRfpServices(allServices.filter((row) => row.rfp === 1))
        setRequestServices(allServices.filter((row) => row.rfp === 0))
      }
    } catch (error) {
      console.error('Error fetching request services:', error)
    }
  }

  const fetchJobNoteMembers = async (request_id) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-job-note-members`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,
        }
      )
      if (res.data.status === 1) {
        setJobNoteMembers(res.data.jobNoteMembers)
      }
    } catch (error) {
      console.error('Error fetching job note members:', error)
    }
  }

  const fetchOrderDetailsData = async (request_id) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}request/get-order-details-data`,
        {
          request_id,
          userId: user.user_id,
          userType: user.user_type,

        }
      )
      if (res.data.status === 1) {
        if (res.data.projectMembers) {
          // setProjectMembers(res.data.projectMembers)
          setDesignersList(res.data.projectMembers)
        }
        setPortfolio(res.data.portfolio)
        setCustomTemplate(res.data.fieldTemplates)
        setQuestionnaireTemplate(res.data.QuestionTemplates)
        setSignAgreements(res.data.signAgrementData)
        setDataEmpty(res.data.allDataEmpty)
        setCustomerData(res.data.customerData)
      }
    } catch (error) {
      console.error('Error fetching order details data:', error)
    }
  }

  const fetchOrderProductDetails = async (orderId) => {
    setLoadingJobCost(true)
    try {
      // let orderId = details?.id;
      const res = await axios.post(
        `${REST_API_END_POINT}get-customer-order-product/${orderId}`,
      )
      await setInvoice(res.data.data)

      localStorage.setItem('params', res?.data?.data?.request_id)
    } catch (error) {
      console.error('Error fetching request details:', error)
      throw error
    } finally {
      setLoadingJobCost(false)
    }
  }
  // const handleUpdateStatus = async (optio) => {
  //   try {
  //     setOpenPopup(false)
  //     setOpenPopupComplete(false)
  //     setValue(optio)
  //     let status = optio?.id
  //     const user = JSON.parse(window.localStorage.getItem('user'))
  //     console.log('ghghfghfghfghfg',completeStatus);
      
  //     // const response = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,{selectedIds,userId:user.user_id})
  //     // const res = await axios.post(`${REST_API_END_POINT}project/update-project-status`,
  //     const res = await axios
  //       .post(
  //         `${REST_API_END_POINT}${
  //           status == 3
  //             ? `installation/convert-job-to-installation`
  //             : `project/update-project-status`
  //         }`,
  //         {
  //           status,
  //           selectedIds: Number(id),
  //           userId: user.user_id,
  //           userType:user.user_Type,
  //           projectId: Number(id),
  //           completeStatus:Number(completeStatus),
  //           clientId : clientId
  //         },
  //         {
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //         },
  //       )
  //       .then((response) => {
  //         if (response.data.status === 1) {
  //           setRefresh(true)
  //           onDataChange()
  //           enqueueSnackbar(
  //            `${status === 3
  //               // ? details?.noServiceNoTask == 1 ? 'Moved To "No Service No Task"' : (Number(completeStatus) === 1
  //               ? details?.noServiceNoTask == 1 ? 'Job completed without installation' : (Number(completeStatus) === 1
  //                   ? 'Moved To Installs'
  //                   : Number(completeStatus) === 2
  //                   ? 'Moved To Pickup'
  //                   : 'Moved To Shipping')
  //               : 'Success'}`,
  //             { variant: 'success' },
  //           )
  //         } else if (response.data.status === 0) {
  //           enqueueSnackbar(
  //             `${status == 3 ?(Number(completeStatus) === 1
  //               ? 'Not Moved To Installs'
  //               : Number(completeStatus) === 2
  //               ? 'Not Moved To Pickup'
  //               : 'Not Moved To Shipping') : 'Failed'}`,
  //             { variant: 'error' },
  //           )
  //         }
  //       })
  //   } catch (error) {
  //     console.error('Error status update:', error)
  //     throw error
  //   }
  // } uncomment this if it causes any error 

  const getAllStageMembers = () => {
    const members = []
    projectTask?.forEach((task) => {
      const taskId = task.id || task.ID
      task.subTasks?.forEach((subtask) => {
        subtask.teamMembers?.forEach((member) => {
          members.push({
            ...member,
            task_id: taskId,
            subtask_id: subtask.id || subtask.ID,
            subtask_name: subtask.name,
            rowKey: `${subtask.id || subtask.ID}-${member.staff_id}`,
          })
        })
      })
    })
    return members
  }

  const updateClockInInput = (rowKey, data) => {
    setClockInInputs((prev) => {
      const exists = prev.find((item) => item.rowKey === rowKey)
      if (exists) {
        return prev.map((item) =>
          item.rowKey === rowKey ? { ...item, ...data } : item
        )
      }
      return [...prev, { rowKey, ...data }]
    })
  }

  const getClockInPayload = () => {
    const now = moment().unix()
    return clockInInputs
      .filter((entry) => entry.hour > 0)
      .map((entry) => {
        const staffMember = subTaskMembers.find((member) => member.rowKey === entry.rowKey)
        const staffName = staffMember?.name || staffMember?.staff_name || 'N/A'
        const taskData = projectTask?.find(
          (task) => (task.id || task.ID) === (entry.task_id || staffMember?.task_id)
        )
        const taskName = taskData?.task_name || taskData?.name || 'N/A'
        return {
          ...entry,
          staff_id: entry.staff_id || staffMember?.staff_id,
          subtask_id: entry.subtask_id || staffMember?.subtask_id,
          subtask_name: entry.subtask_name || staffMember?.subtask_name,
          task_id: entry.task_id || staffMember?.task_id,
          start_time: now - Math.round(entry.hour * 3600),
          end_time: now,
          staff_name: staffName,
          task_name: taskName,
          userId: staffMember?.userId || staffMember?.user_id || entry.userId,
          user_id: staffMember?.userId || staffMember?.user_id || entry.user_id,
          hourly_rate: entry.hourly_rate || staffMember?.hourly_rate,
        }
      })
  }

  const visibleClockInMembers =
    userType === 1 || userType === 8 || userType === 2 || userType === 9
      ? subTaskMembers
      : subTaskMembers.filter(
          (item) => item.userId === userId || item.user_id === userId
        )

  const isClockInDisabled = visibleClockInMembers.every((member) => {
    const entry = clockInInputs.find((e) => e.rowKey === member.rowKey)
    return !(entry?.hour > 0)
  })

  const handleCloseClockIn = () => {
    setOpenService(false)
    setClockInInputs([])
    setSubTaskMembers([])
    setPendingStatusUpdate(null)
  }

  const executeJobStatusUpdate = async (optio, stockData) => {
    const currentUser = JSON.parse(window.localStorage.getItem('user'))
    setValue(optio)

    const status = optio?.id
    const endpoint = 'project/update-project-status'

    const response = await axios.post(
      `${REST_API_END_POINT}${endpoint}`,
      {
        status,
        selectedIds: Number(id),
        userId: currentUser.user_id,
        userType: currentUser.user_Type,
        projectId: Number(id),
        completeStatus: Number(completeStatus),
        clientId: clientId,
        projectCategory: details?.project_category,
        request_id: details?.id,
        stockData: stockData || null,
      },
      { headers: { 'Content-Type': 'application/json' } }
    )

    if (response.data.status === 1) {
      setRefresh(true)
      enqueueSnackbar(
        status === 3 ? 'Job completed' : 'Job status updated successfully',
        { variant: 'success' }
      )
    } else if (response.data.status === 0) {
      enqueueSnackbar('Failed update job status', { variant: 'error' })
    }
  }

  const handleJobCompleteClockIn = async () => {
    setClockInLoading(true)
    const now = moment().unix()
    const memberClockins = getClockInPayload()

    if (memberClockins.length === 0) {
      enqueueSnackbar('Please enter time for at least one member', { variant: 'error' })
      setClockInLoading(false)
      return
    }

    const groups = memberClockins.reduce((acc, entry) => {
      const key = `${entry.task_id}-${entry.subtask_id}`
      if (!acc[key]) {
        acc[key] = { taskId: entry.task_id, subtaskId: entry.subtask_id, entries: [] }
      }
      acc[key].entries.push(entry)
      return acc
    }, {})

    try {
      for (const { taskId, subtaskId, entries } of Object.values(groups)) {
        const res = await axios.post(
          `${REST_API_END_POINT}project-task/update-staff-task-timelog`,
          {
            projectId: id,
            taskId,
            userId,
            isDriver: false,
            memberClockins: entries,
            checkedItems: [String(subtaskId)],
            now,
            request_id: details?.id,
          }
        )
        if (res.data.status !== 1) {
          enqueueSnackbar('Clock-in failed', { variant: 'error' })
          setClockInLoading(false)
          return
        }
      }

      const statusToApply = pendingStatusUpdate
      handleCloseClockIn()
      if (statusToApply) {
        await executeJobStatusUpdate(statusToApply.optio, statusToApply.stockData)
      }
    } catch (error) {
      console.error('Clock-in error:', error)
      enqueueSnackbar('Clock-in failed', { variant: 'error' })
    } finally {
      setClockInLoading(false)
    }
  }

  const handleUpdateStatus = async (optio, stockData, skipClockIn = false) => {
    try {
      const statusId = optio?.id ?? optio
      const completingJob = statusId === 3

      setOpenPopup(false)
      setOpenPopupComplete(false)

      if (completingJob && !skipClockIn) {
        const allMembers = getAllStageMembers()
        if (allMembers.length > 0) {
          setPendingStatusUpdate({ optio, stockData })
          setSubTaskMembers(allMembers)
          setOpenService(true)
          return
        }
      }

      await executeJobStatusUpdate(optio, stockData)
    } catch (error) {
      console.error('Error status update:', error)
      enqueueSnackbar('Something went wrong', { variant: 'error' })
    }
  };

  const handleUpdateHoldStatus = async (reason) => {
    try {
      if (user?.user_type === 3 || !hasHoldEstimateJobsPermission) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
        return;
      }
      // const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-job-hold-status`,
        {
          projectId: Number(id),
          request_id: details?.id,
          userId: user.user_id,
          reason: reason || '',
          estimateJob: true,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        setRefresh(!refresh);
        // onDataChange();
        enqueueSnackbar(res.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  }

  const handleRejectFileDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return
      setIsUploadingRejectFile(true)
      try {
        const uploadedFiles = []
        for (const file of acceptedFiles) {
          const timestamp = Date.now()
          const sanitizedName = file.name.replace(/\s+/g, '_')
          const fileName = `${timestamp}_${sanitizedName}`
          const filePath = `estimate-job/rejected/${fileName}`
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file)
          if (uploadError) throw uploadError
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath)
          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL')
          }
          uploadedFiles.push({
            url: publicUrlData.publicUrl,
            file_type: file.type,
            original_name: file.name,
          })
        }
        setRejectFiles((prev) => [...(Array.isArray(prev) ? prev : []), ...uploadedFiles])
      } catch (err) {
        enqueueSnackbar(`Upload failed: ${err.message}`, { variant: 'error' })
      } finally {
        setIsUploadingRejectFile(false)
      }
    },
    [enqueueSnackbar],
  )

  const handleRejectEstimateJob = async () => {
    if (!rejectReason.trim()) {
      enqueueSnackbar('Please fill rejected reason', { variant: 'warning' })
      return
    }
    try {
      setIsSubmittingReject(true)
      const res = await axios.post(
        `${REST_API_END_POINT}project/reject-estimate-job`,
        {
          projectId: Number(id),
          request_id: details?.id,
          userId: user.user_id,
          reason: rejectReason,
          rejectionFiles: rejectFiles,
        },
        { headers: { 'Content-Type': 'application/json' } },
      )
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' })
        setOpenRejectPopup(false)
        setRejectReason('')
        setRejectFiles([])
        setRefresh(!refresh)
        onDataChange && onDataChange()
      } else {
        enqueueSnackbar(res.data.message || 'Failed to reject', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong while rejecting', { variant: 'error' })
    } finally {
      setIsSubmittingReject(false)
    }
  }

  const handleRestoreEstimateJob = async () => {
    try {
      setIsSubmittingRestore(true)
      const res = await axios.post(
        `${REST_API_END_POINT}project/restore-rejected-estimate-job`,
        {
          projectId: Number(id),
          request_id: details?.id,
          userId: user.user_id,
        },
        { headers: { 'Content-Type': 'application/json' } },
      )
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' })
        setRefresh(!refresh)
        onDataChange && onDataChange()
      } else {
        enqueueSnackbar(res.data.message || 'Failed to restore', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong while restoring', { variant: 'error' })
    } finally {
      setIsSubmittingRestore(false)
    }
  }

  const handlePopup = async (opto) => {
    setOpenPopup(true)        
    setStatus(opto) 
  }
  const handleTab = (event, newValue) => {
    setSecTab(newValue)
    if (newValue === 'Job Notes') {
      clearJobNotesNew()
    }
    // Fetch attachments and order details data only when Order Details tab is clicked
    if (newValue === 'Order Details' && details?.id) {
      fetchRequestAttachments(details.id)
      fetchOrderDetailsData(details.id)
    }
    // Fetch updates only when Job Log tab is clicked
    if (newValue === 'Job Log' && details?.id) {
      fetchRequestUpdates(details.id)
    }
    // Fetch request services only when Locations tab is clicked
    if (newValue === 'Locations' && details?.id) {
      fetchRequestServices(details.id)
    }
    // Fetch job note members only when Job Notes tab is clicked
    if (newValue === 'Job Notes' && details?.id) {
      fetchJobNoteMembers(details.id)
    }
  }
  //////////////////////
  const handleFileChange = async (event) => {
    const files = event.target.files

    if (files.length === 0) {
      return
    }

    const uploadPromises = Array.from(files).map(async (file) => {
      const filename = new Date().getTime() + file.name
      const storageRef = imageref(storage, filename)
      const uploadTask = uploadBytesResumable(storageRef, file)

      return new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const prog = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
            )
            setProgress(true)
          },
          (error) => {
            console.error(error.message)
            setProgress(false)
            reject(error)
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref)
              .then((downloadURL) => {
                resolve({ downloadURL, fileType: getFileType(file.type) })
              })
              .catch((error) => {
                console.error(error.message)
                reject(error)
              })
          },
        )
      })
    })

    try {
      const validFileUploads = await Promise.all(uploadPromises)
      const newAttachments = validFileUploads.reduce(
        (acc, { downloadURL, fileType }) => {
          acc[fileType] = acc[fileType] || []
          acc[fileType].push(downloadURL)
          return acc
        },
        {},
      )

      setAttachments((prevAttachments) => ({
        ...prevAttachments,
        image: [
          ...(prevAttachments.image || []),
          ...(newAttachments.image || []),
        ],
        video: [
          ...(prevAttachments.video || []),
          ...(newAttachments.video || []),
        ],
        other: [
          ...(prevAttachments.other || []),
          ...(newAttachments.other || []),
        ],
      }))
      setProgress(false)
    } catch (error) {
      console.error('Error uploading files:', error)
    }
  }

  const RemoveAttachFromSubmit = (type, value) => {
    const deleteRef = imageref(storage, value)

    deleteObject(deleteRef)
      .then(() => {
        // File deleted successfully
        setAttachments((prevState) => ({
          ...prevState,
          [type]: (prevState[type] || []).filter((item) => item !== value),
        }))
      })
      .catch((error) => {
        console.error('Error deleting file:', error)
      })
  }

  const handleSubmitAttachments = async () => {
    try {
      if (Object.keys(attachments).length === 0) {
        enqueueSnackbar('Please provide attachments', { variant: 'warning' })
        return
      }
      let user = JSON.parse(window.localStorage.getItem('user'))
      const res = await axios.post(
        `${REST_API_END_POINT}project-task/add-project-attachment`,
        {
          attachments,
          taskId,
          projectId,
          userId: user.user_id,
          request_id: details?.id,
        },
      )
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' })
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' })
      }
      setAttachments({})
      setOpenAttachModal(false)
    } catch (error) {
      console.log(error)
    }
  }
  const valuetext = (value) => {
    return `${value}%`
  }
  const updateStatus = (event, value) => {
    let values = {}
    let user = JSON.parse(window.localStorage.getItem('user'))
    values.completion = event.target.value
    values.projectId = Number(id)
    values.added_by = user.user_id
    if (event.target.value && values.projectId) {
      axios.post(
        `${REST_API_END_POINT}project/update-project-progress`,
        { ...values },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          // headers: { 'Content-Type': 'multipart/form-data' }
        },
      )
    }
  }
  // if(loading){

  //   <Stack alignItems='center' justifyContent='center'>
  //     <LoadingScreen  />
  //   </Stack>
  // }
  console.log('##################Loading', loading)
  return (
    <>
      {loading ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: '100vh' }}
        >
          <LoadingScreen />
        </Stack>
      ) : (
        <Container>
          {!isEdit ? (
            <Grid container spacing={3}>
              <Grid key={1} item xs={12} md={8}>
                <HeaderBreadcrumbs
                  sx={{ mt: 2 }}
                  heading={
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        Job Details
                        {isEstimateVoided && (
                          <Label variant="filled" color="error">
                            Void
                          </Label>
                        )}
                      </Box>
                    </Box>
                  }
                  leftAction={
                    <Tooltip title={isFromEstimateLogs ? 'Back to Estimate Logs' : 'Back to All Estimate Jobs'}>
                      <IconButton
                        sx={{ 
                          backgroundColor: theme.palette.divider, 
                          width:40, 
                          height: 40, 
                          marginRight:1, 
                          justifyContent:'center', 
                          alignItems:'center' 
                        }}
                        component={RouterLink}
                        to={estimateBackTo}
                      >
                        {/* <Icon icon={editFill} width={24} height={24} color="#ffffff" /> */}
                        <KeyboardBackspaceOutlined sx={{ color:'#ffffff' }} />
                      </IconButton>
                    </Tooltip>
                  }
                  action={
                    <Stack direction={'row'} spacing={2}>
                      {secTab === 'Tasks' && (
                        <Tabs
                          value={valueTab}
                          onChange={handleChange}
                          textColor="secondary"
                          indicatorColor="none"
                          aria-label="secondary tabs example"
                        >
                          <CustomTab value="one" icon={<ViewModule />} />
                          <CustomTab value="two" icon={<ViewList />} />
                          <CustomTab value="three" icon={<List />} />
                        </Tabs>
                      )}
                    </Stack>
                  }
                />

                <Stack spacing={5}>
                  {currentTab != 'Installs' &&
                    currentTab != 'Pickup' &&
                    currentTab != 'Shipping' &&
                    currentTab != 'Completed' &&
                    data?.status != 3 &&
                    // canHoldEstimateJob && (
                      user.user_type != 3 && (
                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="flex-end"
                      justifyContent="flex-end"
                    >
                      { data?.hold !== 1 && !isEstimateVoided && !isJobRejected && !isEstimateDraft && (
                        <Button
                          variant="contained"
                          onClick={() => {
                            setOpenRejectPopup(true)
                            setRejectReason('')
                            setRejectFiles([])
                          }}
                          sx={{ boxShadow: 'none', color: theme.palette.background.paper,backgroundColor: theme.palette.error.main ,borderRadius: 80,"&:hover": { backgroundColor: theme.palette.error.dark} }}
                        >
                          Reject
                        </Button>
                      )}
                      {isJobRejected && (
                        <Button
                          variant="contained"
                          disabled={isSubmittingRestore}
                          onClick={handleRestoreEstimateJob}
                          sx={{ boxShadow: 'none', color: theme.palette.background.paper ,backgroundColor: theme.palette.success.main,borderRadius: 80,"&:hover": { backgroundColor: theme.palette.success.dark } }}
                        >
                          {isSubmittingRestore ? (
                            <CircularProgress size={18} />
                          ) : (
                            'Reopen'
                          )}
                        </Button>
                      )}
                      {canHoldEstimateJob && !isJobRejected && !isEstimateVoided && (
                      <Button
                        onClick={() => {
                          setOpenHoldPopup(true)
                        }}
                        disabled={user.user_type == 3 ? true : false}
                        sx={{
                          borderRadius: 20,
                          backgroundColor: theme.palette.warning.main,
                          color: 'black',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: theme.palette.warning.dark,
                            boxShadow: 'none',
                          },
                        }}
                        variant="contained"
                      >
                        {data?.hold === 0
                          ? 'Move to Hold'
                          : 'Release from Hold'}
                      </Button>
                      )}
                    </Stack>
                  )}
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={{ xs: 2, md: 0 }}
                    alignItems="center"
                    justifyContent={'space-between'}
                  >
                    {/* {value?.value &&
                    (details?.job_category_name !== 'Time & Material') &&
                    ((data?.status !== 1 && data?.status !== 0) || data?.hold === 1) */}
                    {
                    // value?.value &&
                    (!hasJobPermission || data?.status == 0 || data?.hold === 1 || isJobRejected || isEstimateVoided || !estimateJobStatusUnlocked)
                     ? (
                      <Button
                        sx={{
                          width: '40%',
                          background: isJobRejected || isEstimateVoided ? '#c9302c' : colors[value.id],
                          color: '#ffffff',
                          borderRadius: 1,
                          border: 'none',
                          '&:hover': {
                            // transform: 'scale(1.02)',
                            border: 'none',
                          },
                        }}
                      >
                        {' '}
                        {isEstimateVoided ? 'Void' : isJobRejected ? 'Rejected' : value?.value}{' '}
                      </Button>
                    ) : (
                      <TextField
                        select
                        disabled={isFromEstimateLogs && details.was_from_estimate == 1}
                        size="small"
                        value={value?.value}
                        sx={{
                          width: '35%',
                          background: colors[value?.id],
                          borderRadius: 1,
                          border: 'none',
                          '&:hover': {
                            // transform: 'scale(1.02)',
                            border: 'none',
                          },
                        }}
                      >
                        
                        {options.map((optio) => (
                          <MenuItem
                            onClick={() => {
                              if(isLoggedIn && (optio.id == 3)){
                                enqueueSnackbar('Please clock out from all ongoing jobs before proceeding', { variant: 'warning' })
                                return;
                              }else if(optio.id == 3 && Number(details?.is_draft) === 1){
                                enqueueSnackbar('This estimate is still a draft. Please update it before completing the job.', { variant: 'warning' })
                                return;
                              }else if(details?.is_create_estimate != 1 && (optio.id == 3)){
                                enqueueSnackbar('Please create the estimate before completing', { variant: 'warning' })
                                return;
                              }
                              else if(optio.id == 4){
                                setOpenRejectPopup(true)
                                setRejectReason('')
                                setRejectFiles([])
                              }
                              else{
                                if ((value?.id === 2 || value?.id === 3) && optio.id === 1 && details?.is_create_estimate == 1) {
                                  enqueueSnackbar("Job started, can't switch back to New", { variant: 'warning' })
                                  return
                                }
                                // setValue(optio)
                                // handleUpdateStatus(optio.id)
                                // Check subtask validation first (priority)
                                const isTimeAndMaterialJob = details?.project_category === 12;
                                if (isTimeAndMaterialJob) {
                                  const hasEmptySubTask = projectTask?.some(
                                    (task) => task.is_manually_added === 1 && task.subtask_count === 0
                                  );
                                
                                  if (hasEmptySubTask) {
                                    setOpenSubtaskValidationPopup(true);
                                    return; // stop further execution
                                  }
                                }

                                // Only check service workflow condition if subtask validation passes for all tasks
                                const hasServiceWorkflowIssue = projectTask?.some(
                                  (task) => task.service_id &&isTimeAndMaterialJob && !task.service_workflow && task.subtask_count === 0
                                );
                                
                                if (hasServiceWorkflowIssue) {
                                  setSelectedOption(optio);
                                  setOpenServiceWorkflowConfirmation(true);
                                  return; // stop further execution
                                }
                                //Autocomplete for status
                                handlePopup(optio)
                              }
                            }}
                            disabled={
                              (option.value === 'Completed' && details?.quotation_status != 3) || loadingJobCost ||
                              user.user_type == 3
                                ? true
                                : false
                            }
                            key={optio.value}
                            value={optio.value}
                          >
                            {optio.value}
                          </MenuItem>
                        ))}
                      </TextField>
                      )
                    }
                    <ConfirmationPopup
                      open={openPopup}
                      handleClick={() => {
                        handleUpdateStatus(status)
                      }}
                      handleClose={() => {
                        setOpenPopup(!openPopup)
                      }}
                      message={`All tasks and subtasks have been moved to the ${status?.value} state`}
                    />
                      {status?.id === 3 && (details?.project_category === 15 && details?.is_split_order !== 1) ? (
                        <Dialog open={openPopupComplete} onClose={() => setOpenPopupComplete(false)}>
                          <DialogContent sx={{mb:-2}}>
                            <Stack direction="column" spacing={2}>
                              <Typography variant='h6'>Are you sure you want to complete this Job?</Typography>
                              {/* <Alert severity="info">
                                If this job is completed, stock will be added to the selected Catalog. Once completed, this job & sales order will move directly to the Completed tab.
                              </Alert> */}
                            </Stack>
                          </DialogContent>
                          <DialogActions>
                            <Button variant='outlined' color='inherit' onClick={() => setOpenPopupComplete(false)}>No</Button>
                            <Button
                              variant="contained"
                              sx={{ boxShadow: 'none' }}
                              onClick={() => {
                                setOpenPopupComplete(false);
                                handleUpdateStatus(status);
                              }}
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                      ) : (
                        <ConfirmationPopup
                          isComplete={true}
                          setCompleteStatus={setCompleteStatus}
                          noServiceNoTask={details?.noServiceNoTask}
                          projectCategory={details?.project_category}
                          projectId={id}
                          projectTasks={projectTask}
                          open={openPopupComplete}
                          handleClick={(stockData) => {
                            handleUpdateStatus(status, stockData)
                          }}
                          hideCancel={true}
                        />
                      )}
                    {/* <ConfirmationPopup
                    isComplete={true}
                    setCompleteStatus={setCompleteStatus}
                    noServiceNoTask={details?.noServiceNoTask}
                      open={openPopupComplete}
                      handleClick={() => {
                        handleUpdateStatus(status)
                      }}
                       hideCancel={true}

                      // handleClose={() => {
                      //   setOpenPopupComplete(!openPopupComplete)
                      // }}
                      // message={`All tasks and subtasks have been moved to the ${status?.value} state`}
                    /> */}
                    <Dialog
                      open={openHoldPopup}
                      onClose={() => {
                        setOpenHoldPopup(false);
                        setHoldReason('');
                      }}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                      BackdropProps={{ invisible: true }}
                    >
                      <DialogTitle id="alert-dialog-title">
                        {data?.hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          {data?.hold === 1
                            ? 'You want to move this Job from Hold.'
                            : 'You want to move this Job to Hold.'}
                        </DialogContentText>
                        {(data?.hold === 0) ? (
                          <TextField
                            sx={{ width: 400, mt: 2 }}
                            label="Reason"
                            type="text"
                            multiline
                            minRows={3}
                            maxRows={7}
                            value={holdReason}
                            onChange={(e) => {
                              setHoldReason(e.target.value);
                              if (holdReasonError) setHoldReasonError('');
                            }}
                            error={Boolean(holdReasonError)}
                            helperText={holdReasonError}
                          />
                        ) : ''}
                      </DialogContent>
                      <DialogActions>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={async () => {
                            if ((data?.hold === 0) && !holdReason.trim()) {
                              setHoldReasonError('Reason is required to put this Job on Hold.');
                              return;
                            }

                            setIsSubmittingHold(true);
                            await handleUpdateHoldStatus(holdReason);
                            setIsSubmittingHold(false);
                            setOpenHoldPopup(false);
                            setHoldReason('');
                            setHoldReasonError('');
                          }}
                          disabled={isSubmittingHold}
                        >
                          {isSubmittingHold ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            'OK'
                          )}
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setOpenHoldPopup(false);
                            setHoldReason('');
                          }}
                          sx={{ color: theme.palette.error.main }}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Dialog
                      open={openRejectPopup}
                      onClose={() => {
                        if (isSubmittingReject || isUploadingRejectFile) return
                        setOpenRejectPopup(false)
                      }}
                      aria-labelledby="reject-estimate-job-view-title"
                      BackdropComponent={Backdrop}
                      BackdropProps={{ invisible: true }}
                      PaperProps={{
                        sx: {
                          width: 700,
                          borderRadius: 2,
                          bgcolor: '#0f1b1e',
                          border: '1px solid rgba(255,255,255,0.12)',
                        },
                      }}
                    >
                      <DialogTitle id="reject-estimate-job-view-title" sx={{ fontWeight: 600, color: '#fff' }}>
                        Reject Estimate Job
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText sx={{ color: 'grey.400', mb: 2 }}>
                          Rejecting will move this job and its estimate to the Rejected tab.
                        </DialogContentText>
                        <TextField
                          fullWidth
                          label="Reason For Rejection"
                          type="text"
                          multiline
                          minRows={3}
                          maxRows={7}
                          value={rejectReason}
                          onChange={(e) => setRejectReason(e.target.value)}
                          sx={{
                            mb: 2,
                            bgcolor: 'rgba(255,255,255,0.05)',
                            borderRadius: 1,
                            input: { color: '#fff' },
                            '& .MuiInputLabel-root': { color: 'grey.400' },
                          }}
                        />
                        <UploadMultiFile
                          showPreview
                          files={rejectFiles || []}
                          maxSize={1024 * 1024 * 1024}
                          multiple
                          onDrop={handleRejectFileDrop}
                          onRemove={(file) => setRejectFiles((prev) => (Array.isArray(prev) ? prev : []).filter((f) => f !== file))}
                          onRemoveAll={() => setRejectFiles([])}
                          isUploading={isUploadingRejectFile}
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={handleRejectEstimateJob}
                          disabled={isSubmittingReject || isUploadingRejectFile}
                        >
                          {isSubmittingReject ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            'Submit Reject'
                          )}
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setOpenRejectPopup(false)
                            setRejectReason('')
                            setRejectFiles([])
                          }}
                          sx={{ color: theme.palette.error.main }}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Dialog
                      open={openSubtaskValidationPopup}
                      onClose={() => setOpenSubtaskValidationPopup(false)}
                      aria-labelledby="subtask-validation-dialog-title"
                      aria-describedby="subtask-validation-dialog-description"
                    >
                      <DialogTitle id="subtask-validation-dialog-title">
                        Cannot Change Status
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="subtask-validation-dialog-description">
                        Each task must have at least one sub task to change status
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button 
                          onClick={() => setOpenSubtaskValidationPopup(false)}
                          variant="contained"
                          color="primary"
                        >
                          OK
                        </Button>
                      </DialogActions>
                    </Dialog>
                    
                    <Dialog
                      open={openServiceWorkflowConfirmation}
                      onClose={() => setOpenServiceWorkflowConfirmation(false)}
                      aria-labelledby="service-workflow-confirmation-dialog-title"
                      aria-describedby="service-workflow-confirmation-dialog-description"
                    >
                      <DialogTitle id="service-workflow-confirmation-dialog-title">
                        Confirm Status Change
                      </DialogTitle>
                      <DialogContent>
                        {(() => {
                          const affectedTasks = projectTask?.filter(task => task.service_id && !task.service_workflow) || [];
                          const isSingle = affectedTasks.length === 1;
                          
                          return (
                            <>
                              <DialogContentText id="service-workflow-confirmation-dialog-description">
                                {isSingle 
                                  ? "The following task has no service workflow assigned:"
                                  : "The following tasks have no service workflow assigned:"
                                }
                              </DialogContentText>
                              <Box sx={{ mt: 2 }}>
                                {affectedTasks.map((task, index) => (
                                  <Typography key={index} variant="body2" sx={{ mb: 1, fontWeight: 'medium' }}>
                                    • {task.name || `Task ${task.id}`}
                                  </Typography>
                                ))}
                              </Box>
                              <DialogContentText sx={{ mt: 2 }}>
                                Are you sure you want to change the status?
                              </DialogContentText>
                            </>
                          );
                        })()}
                      </DialogContent>
                      <DialogActions>
                        <Button 
                          onClick={() => setOpenServiceWorkflowConfirmation(false)}
                          variant="outlined"
                          color="error"
                        >
                          Cancel
                        </Button>
                        <Button 
                          onClick={() => {
                            setOpenServiceWorkflowConfirmation(false);
                            handlePopup(selectedOption);
                          }}
                          variant="contained"
                          color="primary"
                        >
                          Confirm
                        </Button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      aria-describedby="job-complete-clock-in-dialog"
                      TransitionComponent={ClockInTransition}
                      transitionDuration={500}
                      open={openService}
                      PaperProps={{
                        sx: {
                          width: { xs: '90%', sm: '60%', md: '70%' },
                          p: 2,
                          borderRadius: 2,
                        },
                      }}
                    >
                      <DialogContent
                        sx={{
                          mt: 1,
                          px: 2,
                          overflowY: 'auto',
                          overflowX: 'auto',
                          maxHeight: 500,
                        }}
                      >
                        <Table size="small" sx={{ minWidth: 500 }}>
                          <TableHead>
                            <TableRow>
                              <TableCell align="center" sx={{ width: '30%', py: 1 }}>
                                <strong>Member</strong>
                              </TableCell>
                              <TableCell align="center" sx={{ width: '25%', py: 1 }}>
                                <Box>
                                  <Typography variant="subtitle2" fontWeight="bold">
                                    Time
                                  </Typography>
                                  <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                                    (HH:MM)
                                  </Typography>
                                </Box>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {visibleClockInMembers.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={2} align="center">
                                  No job members available
                                </TableCell>
                              </TableRow>
                            ) : (
                              visibleClockInMembers.map((item) => (
                                <TableRow key={item.rowKey} sx={{ mt: 2, height: 44 }}>
                                  <TableCell align="center">
                                    {item.subtask_name ? `${item.name} - ${item.subtask_name}` : item.name}
                                  </TableCell>
                                  <TableCell>
                                    <Stack direction="row" spacing={1} justifyContent="center">
                                      <TextField
                                        name="hours"
                                        label="Hours"
                                        placeholder="01"
                                        size="small"
                                        sx={{ width: 80 }}
                                        inputProps={{ min: 0 }}
                                        onKeyDown={(e) => {
                                          const allowedKeys = [
                                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                                          ]
                                          if (!allowedKeys.includes(e.key)) {
                                            e.preventDefault()
                                          }
                                        }}
                                        onChange={(e) => {
                                          const h = parseInt(e.target.value || '0', 10)
                                          const m = parseInt(
                                            e.target.closest('tr').querySelector('input[name="minutes"]')?.value || '0',
                                            10,
                                          )
                                          const totalMinutes = h * 60 + m
                                          const decimal = Math.round((totalMinutes / 60) * 10000) / 10000
                                          updateClockInInput(item.rowKey, {
                                            hour: decimal,
                                            hourly_rate: item.hourly_rate,
                                            userId: item.userId || item.user_id,
                                            staff_id: item.staff_id,
                                            task_id: item.task_id,
                                            subtask_id: item.subtask_id,
                                            subtask_name: item.subtask_name,
                                          })
                                        }}
                                      />
                                      <TextField
                                        label="Minutes"
                                        name="minutes"
                                        placeholder="30"
                                        size="small"
                                        sx={{ width: 80 }}
                                        inputProps={{ min: 0, max: 60 }}
                                        onKeyDown={(e) => {
                                          const allowedKeys = [
                                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                                          ]
                                          if (!allowedKeys.includes(e.key)) {
                                            e.preventDefault()
                                          }
                                        }}
                                        onInput={(e) => {
                                          const value = parseInt(e.target.value || '0', 10)
                                          if (value > 60) {
                                            e.target.value = 60
                                          } else if (value < 0) {
                                            e.target.value = 0
                                          }
                                        }}
                                        onChange={(e) => {
                                          let m = parseInt(e.target.value || '0', 10)
                                          let h = parseInt(
                                            e.target.closest('tr').querySelector('input[name="hours"]')?.value || '0',
                                            10,
                                          )
                                          const totalMinutes = h * 60 + m
                                          const decimal = Math.round((totalMinutes / 60) * 10000) / 10000
                                          updateClockInInput(item.rowKey, {
                                            hour: decimal,
                                            hourly_rate: item.hourly_rate,
                                            userId: item.userId || item.user_id,
                                            staff_id: item.staff_id,
                                            task_id: item.task_id,
                                            subtask_id: item.subtask_id,
                                            subtask_name: item.subtask_name,
                                          })
                                        }}
                                      />
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </DialogContent>
                      <Stack direction="row" justifyContent="flex-end" spacing={2} px={3} mt={1} pb={2}>
                        <Button
                          onClick={() => {
                            handleCloseClockIn()
                            enqueueSnackbar('Operation was cancelled', { variant: 'error' })
                          }}
                          sx={{
                            background: '#BB2525',
                            color: '#fff',
                            '&:hover': {
                              background: '#FF8F8F',
                            },
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          onClick={handleJobCompleteClockIn}
                          disabled={isClockInDisabled}
                        >
                          {clockInLoading ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            'Clock In'
                          )}
                        </Button>
                      </Stack>
                    </Dialog>
                    
                    <Stack direction={'row'} spacing={1} alignItems="center" flexWrap="wrap">
                      {loadingJobCost ? (
                        <Stack
                          flexDirection={'row'}
                          alignItems="center"
                          justifyContent="center"
                        >
                          {/* <Typography variant='subtitle2'>Loading Job Cost...</Typography> */}
                          <CircularProgress
                            color="primary"
                            variant="indeterminate"
                            size="20px"
                          />
                        </Stack>
                      ) : (
                        user.user_type !== 3 && (
                          <>
                            {canViewEstimateJobCost && hasViewCostPermission ? (
                              popupOn ? (
                                <Button
                                  onClick={() => handleClickforProject(id, 'Labor')}
                              // onClick={() => {
                              //   // if(details?.job_category_name == 'Time & Material'){ 
                              //   //   const params = details.id
                              //   //   navigate(`${PATH_DASHBOARD.project.jobCost}/${id}`,
                              //   //     {state: { request: params,currentTab : currentTab }});
                              //   // }else{
                              //     navigate(
                              //       PATH_DASHBOARD.project.recipeCost + '/' + id,
                              //       { state: { currentTab: currentTab } },
                              //     )
                              //   // }
                              // }}
                              sx={{ borderRadius: 20 }}
                              variant="outlined"
                            >
                              Job Cost
                            </Button>
                              ) : (
                                <Button
                            // onClick={()=>handleClickforProject(id,currentTab)}
                            onClick={() => {
                              // if(details?.job_category_name == 'Time & Material'){ 
                              //   const params = details.id
                              //   navigate(`${PATH_DASHBOARD.project.jobCost}/${id}`,
                              //     {state: { request: params,currentTab : currentTab }});
                              // }else{
                                navigate(
                                  PATH_DASHBOARD.project.recipeCost + '/' + id,
                                  { state: { currentTab: 'Labor', estimateJob: true } },
                                )
                              // }
                            }}
                            sx={{ borderRadius: 20 }}
                            variant="outlined"
                          >
                            Job Cost
                          </Button>
                              )
                            ) : null}
                          </>
                        )
                      )}

                      <Tooltip
                        title={
                          details?.status === 0
                            ? 'Request has been deleted'
                            : ''
                        }
                      >
                        {canViewEstimateDetails ? (
                          <Button
                            // onClick={() => setOpenInvoice(!openInvoice)}
                            onClick={() => {
                              details?.status == 0
                                ? ''
                                : navigate(
                                    `/dashboard/quick-bid/view/${details?.id}`,
                                    {
                                      state: {
                                        fromProjects: true,
                                        projectId: id,
                                        currentTab,
                                      },
                                    }
                                  )
                            }}
                            // disabled={details?.status === 0}
                            disabled={loadingJobCost}
                            sx={{
                              borderRadius: 20,
                              background: details?.status == 0 ? '#ed2424' : '',
                              border: details?.status == 0 ? '#ed2424' : '',
                              color: details?.status == 0 ? '#ffff' : '',
                            }}
                            variant="outlined"
                          >
                            Estimate Details
                          </Button>
                        ) : null}
                      </Tooltip>
                      {// secTab === 'Tasks'&& details?.job_category_name!='Service only' &&
                      user.user_type !== 3 &&
                        currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                        secTab === 'Tasks' &&
                        currentTab != 'Completed' &&
                        currentTab != 'Hold' &&
                        data?.status != 3 &&
                        data?.hold != 1 &&
                        !isEstimateVoided &&
                        data?.is_rejected != 1 &&
                        canAddEstimateJobTask && (
                          <Button
                            onClick={() => {
                              setAdd(!add)
                            }}
                            disabled={user.user_type == 3 ? true : false}
                            sx={{ borderRadius: 20 }}
                            variant="contained"
                          >
                            Add Task
                          </Button>
                        )}
                      {/* && details?.job_category_name!='Service only' */}
                      {secTab === 'Members' &&
                        user.user_type !== 3 &&
                        currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                        currentTab != 'Completed' &&
                        currentTab != 'Hold' &&
                        // data?.status != 3 &&
                        data?.hold != 1 &&
                        !isEstimateVoided &&
                        data?.is_rejected != 1 &&
                        canAddEstimateJobMember && (
                          <Button
                            disabled={user.user_type == 3 ? true : false}
                            onClick={() => {
                              setAddMember(true)
                            }}
                            sx={{ borderRadius: 20 }}
                            variant="contained"
                          >
                            Add Member
                          </Button>
                        )}
                    </Stack>
                  </Stack>
                  <Stack sx={{ alignItems: 'center', mb: 2 }} spacing={2}>
                    <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
                      <Tabs
                        value={secTab}
                        scrollButtons="auto"
                        variant="scrollable"
                        allowScrollButtonsMobile
                        onChange={handleTab}
                        sx={{
                          width: '100%',
                          '& .MuiTabs-scrollButtons': {
                            '&.Mui-disabled': {
                              opacity: 0.3,
                            },
                          },
                          '& .MuiTabs-flexContainer': {
                            gap: 1,
                          },
                          '& .MuiTab-root': {
                            minWidth: 'auto',
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            padding: '6px 16px',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                            textTransform: 'none',
                            [theme.breakpoints.down('sm')]: {
                              padding: '6px 12px',
                              fontSize: '0.7rem',
                            },
                          },
                          '& .MuiTabs-scroller': {
                            overflow: 'auto !important',
                            '&::-webkit-scrollbar': {
                              height: 6,
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: 'rgba(0,0,0,0.1)',
                              borderRadius: 3,
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: 'rgba(0,0,0,0.3)',
                              borderRadius: 3,
                              '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.5)',
                              },
                            },
                          },
                        }}
                      >
                        {TABS.map((tab) => (
                          <Tab
                            disableRipple
                            key={tab.value}
                            label={
                              <Typography variant="overline" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                {capitalCase(tab.value)}
                                {tab.value === 'Job Notes' && jobNotesHasNew && (
                                  <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                                )}
                              </Typography>
                            }
                            icon={tab.icon}
                            value={tab.value}
                          />
                        ))}
                      </Tabs>
                    </Box>

                    {TABS.map((tab) => {
                      const isMatched = tab.value === secTab

                      return (
                        isMatched && (
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              ...(secTab === 'Attachments'
                                ? { width: '80%' }
                                : secTab === 'Locations'
                                ? { width: '100%' }
                                : { width: '100%' }),
                            }}
                            key={tab.value}
                          >
                            {tab.component}
                          </Box>
                        )
                      )
                    })}
                  </Stack>
                </Stack>
              </Grid>
              <Grid key={2} item xs={12} md={4}>
                <Card sx={{ minHeight: 100 }}>
                  <Stack width={'100%'}>
                    {/* <Box component={'image'}>
                <img
                  src={
                    data?.cover_image && data?.cover_image !=='DefaultThumbnailURL' ? data?.cover_image : 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'
                  }
                  alt="img"
                />
              </Box> */}
                    <Slider {...settings}>
                      {designs
                        .filter(
                          (row) =>
                            row.approved === 1 &&
                            (row?.file_type?.startsWith('image/') ||
                              row.file_type == 'img'),
                        )
                        ?.map((item) => (
                          <Box sx={{ position: 'relative' }}>
                            <CarouselImgStyle src={item.name} />
                            {/* <Box
                        sx={{
                          top: 0,
                          width: '100%',
                          height: '100%',
                          position: 'absolute',
                          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
                        }}
                      /> */}
                            <CardContent
                              sx={{
                                left: 0,
                                bottom: -40,
                                maxWidth: '80%',
                                textAlign: 'left',
                                position: 'absolute',
                                color: 'common.white',
                              }}
                            >
                              <Typography
                                noWrap
                                variant="h5"
                                sx={{ mt: 1, mb: 3 }}
                              >
                                {
                                  details?.job_category_name == 'Service only' ? 'Designs':
                                'Approved Designs'
                                }
                              </Typography>
                            </CardContent>
                          </Box>
                        ))}
                    </Slider>
                    <Box>
                      <Typography
                        variant="overline"
                        sx={{
                          mt: 3,
                          ml: 2,
                          display: 'block',
                          // color: 'text.secondary',
                        }}
                      >
                        Project Completion:
                        {singleProjectData?.result.completion}%
                      </Typography>

                      {/* {singleProjectData && <Sliderw
                    aria-label="Percentage"
                    defaultValue={singleProjectData.result.completion}
                    getAriaValueText={valuetext}
                    onChange={updateStatus}
                    valueLabelDisplay="auto"
                    //  step={10}
                    marks
                    min={10}
                    max={100}
                  />} */}
                    </Box>
                    <Box
                      sx={{
                        my: 2,
                        mx: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Stack width={'100%'} spacing={3}>
                        <Stack
                          direction={'row'}
                          justifyContent={'space-between'}
                          alignItems={'center'}
                        >
                          <Typography variant="h4">{data?.name}</Typography>
                        </Stack>
                        <Typography variant="caption">
                          {data?.description}
                        </Typography>
                        <Stack
                          display={'flex'}
                          direction={'row'}
                          justifyContent={'space-between'}
                        >
                          <Grid container>
                            <Grid item xs={2}>
                              <Stack spacing={1.7}>
                                <Groups sx={{ width: 17 }} />
                                <Attachment sx={{ width: 15 }} />
                                <CheckCircle sx={{ width: 15 }} />
                                <Error sx={{ width: 17 }} />
                              </Stack>
                            </Grid>
                            <Grid item xs={8}>
                              <Stack spacing={2}>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Members')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Members
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => {
                                    if (canViewEstimateJobAttachments) setSecTab('Attachments')
                                  }}
                                  style={{
                                    cursor: canViewEstimateJobAttachments ? 'pointer' : 'default',
                                    opacity: canViewEstimateJobAttachments ? 1 : 0.5,
                                  }}
                                >
                                  Attachment
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Completed Tasks
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  Pending Tasks
                                </Typography>
                              </Stack>
                            </Grid>
                            <Grid item xs={2}>
                              <Stack spacing={2}>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Members')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {data?.member_count}
                                </Typography>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => {
                                    if (canViewEstimateJobAttachments) setSecTab('Attachments')
                                  }}
                                  style={{
                                    cursor: canViewEstimateJobAttachments ? 'pointer' : 'default',
                                    opacity: canViewEstimateJobAttachments ? 1 : 0.5,
                                  }}
                                >
                                  {data?.attachment_count}
                                </Typography>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {data?.completed_task_count}
                                </Typography>
                                <Typography
                                  textAlign={'right'}
                                  variant="subtitle2"
                                  onClick={() => setSecTab('Tasks')}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {data?.pending_task_count}
                                </Typography>
                              </Stack>
                            </Grid>
                          </Grid>
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>
                </Card>
                {isEstimateVoided && details?.reason && (
                  <Box sx={{ width: '100%', mt: 2 }}>
                    <Box
                      sx={{
                        backgroundColor: theme.palette.mode === 'light' ? '#f5f5f5' : '#122227',
                        border: `1px solid ${theme.palette.mode === 'light' ? '#e0e0e0' : '#2a3b40'}`,
                        borderRadius: 1,
                        p: 2,
                        maxWidth: '100%',
                        wordBreak: 'break-word',
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: theme.palette.error.main,
                          fontWeight: 'bold',
                          mb: 1,
                        }}
                      >
                        Void Reason
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: theme.palette.text.primary,
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {details.reason}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Grid>
            </Grid>
          ) : (
            <>
              <HeaderBreadcrumbs heading={'Edit Job'} links={''} action={''} />
              <AddProject
                singleProjectData={singleProjectData}
                setRenderCards={setRenderCards}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                setAdd={setAdd}
              />
            </>
          )}
          <Modal
            modalTitle={'Estimate Order Details'}
            open={openInvoice === true}
            handleClose={() => setOpenInvoice(false)}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row', md: 'column' }}
              spacing={{ xs: 3, sm: 2 }}
            >
              <Stack
                direction="row"
                justifyContent={'flex-end'}
                alignItems="center"
                spacing={1}
              >
                <ReactToPrint
                  trigger={() => (
                    <Button>
                      {' '}
                      <Print />
                      Print
                    </Button>
                  )}
                  content={() => componentRef.current}
                  copyStyles={false}
                  pageStyle={`
               @media print {
                 body {
                   font-size: 12pt
                 }
                 table {
                   width: 100%;
                   border-collapse: collapse;
                   margin-bottom: 10px;
                  
                 }
     
                 th, td {
                   border: 1px solid #ddd;
                   padding: 8px;
                   text-align: left;
                 
                 }
               }
             `}
                />
                <div style={{ display: 'none' }}>
                  <PrintFunction
                    details={details}
                    invoice={invoice}
                    data1={data1}
                    ref={componentRef}
                  />
                </div>
                {/* <Button><Print />Print</Button> */}
              </Stack>
            </Stack>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Typography variant="body2">{COMPANY_NAME}</Typography>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data1?.company_website}</Typography>
                <Typography variant="body2">
                  {data1?.address}, {data1?.city}, {data1?.state},{' '}
                  {data1?.zipcode}
                </Typography>
                {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase', }}>Telephone: {(data1?.phone_country_code || data1?.phone) ? `+${data1?.phone_country_code}${data1?.phone}` : '951-682-9660'}</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>|</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data1?.company_fax_number ? `Fax: ${data1?.company_fax_number}` : ''}</Typography>
                </Box>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data1?.company_mail}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Typography variant="body2">
                  Order date:{' '}
                  {moment.unix(details?.timestamp).format('DD/MM/YYYY')}
                </Typography>
                {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
                {/* <Typography variant="body2">Order status:</Typography> */}
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={getStatusColorAndLabel(details?.status).color}
                >
                  {getStatusColorAndLabel(details?.status).label}
                </Label>
                {/* </Stack> */}
                <Typography variant="body2">Order ID: #{details?.doc_number}</Typography>
                <Typography variant="body2">
                  Job Name: {details?.name}
                </Typography>
                <Typography variant="body2">
                  Client Name: {customerData?.customer_name}
                </Typography>
                <Typography variant="body2">
                  Phone:{' '}
                  {customerData?.customer_phone &&
                    '+' + customerData?.customer_phone}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Scrollbar>
                <TableContainer sx={{ minWidth: 420 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>PRODUCT</TableCell>
                        <TableCell>UNIT PRICE</TableCell>
                        <TableCell>QTY</TableCell>
                        <TableCell>DISCOUNT</TableCell>
                        <TableCell>SUB TOTAL</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice?.cust_product?.map((val) => {
                        const {
                          vid,
                          product_name,
                          product_price,
                          quantity,
                          product_total,
                          discount,
                        } = val
                        return (
                          <TableRow
                            key={vid}
                            sx={{
                              borderBottom: (theme) =>
                                `solid 1px ${theme.palette.divider}`,
                            }}
                          >
                            <TableCell>{product_name}</TableCell>
                            <TableCell>{product_price}</TableCell>
                            <TableCell>{quantity}</TableCell>
                            <TableCell>{discount}</TableCell>
                            <TableCell>{product_total}</TableCell>
                          </TableRow>
                        )
                      })}

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">Subtotal</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">
                            {invoice?.sub_total}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">
                            Extra Discount
                          </Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">
                            {invoice?.extra_discount}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      {/* <RowResultStyle>
                    <TableCell colSpan={3} />
                    <TableCell align="center">
                      <Typography variant="overline">Total Discount</Typography>
                    </TableCell>
                    <TableCell align="center" width={10}>
                      <Typography variant="overline">$0</Typography>
                    </TableCell>
                    
                  </RowResultStyle> */}
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="subtitle1">Total</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="subtitle1">
                            {invoice?.total}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
              {/* </Card>   */}
            </Grid>
          </Modal>
          {/* this modal represent adding of attachments */}
          <Modal
            modalTitle={'Add Attachments'}
            open={openAttachModal}
            handleClose={() => setOpenAttachModal(false)}
          >
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'flex-start'}
              spacing={{ xs: 2, sm: 3 }}
              mb={2}
            >
              <LoadingButton
                variant="outlined"
                size="small"
                sx={{ height: 40 }}
                onClick={() => fileInputRef.current.click()}
                loading={progress}
              >
                <UploadFileSharp /> Upload
              </LoadingButton>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                multiple
              />
            </Stack>
            <Box>
              <Scrollbar sx={{ width: '100%', height: 250 }}>
                <ImageList gap={8} cols={mdd ? 1 : xld ? 3 : 2}>
                  {attachments?.video &&
                    attachments.video.map((videoUrl, index) => (
                      <ImageListItem key={index}>
                        <ImageListItemBar
                          actionIcon={
                            <UserMoreMenu
                              onDelete={() =>
                                RemoveAttachFromSubmit('video', videoUrl)
                              }
                              noEdit
                            />
                          }
                        />
                        <video width="300" height="300" controls>
                          <source
                            src={`${videoUrl}?w=300&h=300&fit=crop&auto=format`}
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </ImageListItem>
                    ))}
                  {attachments?.other &&
                    attachments?.other.map((url, index) => (
                      <Card
                        key={index}
                        sx={{ p: 3, maxWidth: 368, mx: 'auto' }}
                      >
                        <embed
                          src={url}
                          type="application/pdf"
                          width="300"
                          height="300px"
                        />
                        <UserMoreMenu
                          onDelete={() => RemoveAttachFromSubmit('other', url)}
                          noEdit
                        />
                      </Card>
                    ))}
                  {attachments?.image &&
                    attachments.image.map((imageUrl, index) => (
                      <ImageListItem key={index}>
                        <img
                          srcSet={`${imageUrl}?w=248&fit=crop&auto=format&dpr=2 2x`}
                          src={`${imageUrl}?w=248&fit=crop&auto=format`}
                          loading="lazy"
                        />
                        <ImageListItemBar
                          actionIcon={
                            <UserMoreMenu
                              onDelete={() =>
                                RemoveAttachFromSubmit('image', imageUrl)
                              }
                              noEdit
                            />
                          }
                        />
                      </ImageListItem>
                    ))}
                </ImageList>
              </Scrollbar>
            </Box>
            <Box
              sx={{
                mt: 3,
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
              }}
            >
              <LoadingButton
                onClick={() => handleSubmitAttachments()}
                variant="contained"
                size="small"
              >
                Submit
              </LoadingButton>
              <Button
                variant="outlined"
                onClick={() => {
                  setAttachments({}), setOpenAttachModal(false)
                }}
                size="small"
              >
                Cancel
              </Button>
            </Box>
          </Modal>
          <AddTask
            coverImg={designs.length ? designs[0].name : ''}
            projectMembers={projectMembers}
            projectId={Number(id)}
            title={'Add Task'}
            add={add}
            setIsOpen={setIsOpen}
            setAdd={setAdd}
            details={details}
            requestId={details?.id}
            isTimeAndMaterial={details?.project_category === 12}
            onRefresh={() => {
              setRefresh(!refresh)
            }}
            estimateJob={true}
          />
          <AddMember
            allTeamMembers={allTeamMembers}
            projectId={Number(id)}
            prevProjectMembers={projectMembers}
            add={addMember}
            setIsOpen={setIsOpen}
            setAdd={setAddMember}
            onRefresh={() => {
              setRefresh(!refresh)
            }}
          />
        </Container>
      )}
    </>
  )
}

const PrintFunction = forwardRef(({ details, invoice, data1 }, ref) => {
  const theme = useTheme()
  return (
    <Stack ref={ref}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
          <Typography variant="body2">{COMPANY_NAME}</Typography>
          <Typography variant="body2">www.{COMPANY_NAME}.com</Typography>
          <Typography variant="body2">
            {data1?.address}, {data1?.city}, {data1?.state}, {data1?.zipcode}
          </Typography>
          {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
          <Typography variant="body2">Telephone: {data1?.phone ? `+${data1?.phone_country_code}${data1?.phone}` : ''}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
          <Typography variant="body2">
            Order date: {moment.unix(details?.timestamp).format('DD/MM/YYYY')}
          </Typography>
          {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
          {/* <Typography variant="body2">Order status:</Typography> */}
          <Label
            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
            color={getStatusColorAndLabel(details?.status).color}
          >
            {getStatusColorAndLabel(details?.status).label}
          </Label>
          {/* </Stack> */}
          <Typography variant="body2">Order ID: #{details?.doc_number}</Typography>
          <Typography
            paragraph
            variant="overline"
            sx={{ color: 'text.disabled', marginTop: '20px' }}
          >
            TO {invoice?.customer_name}
          </Typography>
          <Typography variant="body2">
            Phone:{invoice?.customer_phone}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 420 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>PRODUCT</TableCell>
                  <TableCell>UNIT PRICE</TableCell>
                  <TableCell>QTY</TableCell>
                  <TableCell>DISCOUNT</TableCell>
                  <TableCell>SUB TOTAL</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice?.cust_product?.map((val) => {
                  const {
                    vid,
                    product_name,
                    product_price,
                    quantity,
                    product_total,
                    discount,
                  } = val
                  return (
                    <TableRow
                      key={vid}
                      sx={{
                        borderBottom: (theme) =>
                          `solid 1px ${theme.palette.divider}`,
                      }}
                    >
                      <TableCell>{product_name}</TableCell>
                      <TableCell>{product_price}</TableCell>
                      <TableCell>{quantity}</TableCell>
                      <TableCell>{discount}</TableCell>
                      <TableCell>{product_total}</TableCell>
                    </TableRow>
                  )
                })}

                <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="overline">Subtotal</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="overline">
                      {invoice?.sub_total}
                    </Typography>
                  </TableCell>
                </RowResultStyle>
                <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="overline">Extra Discount</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="overline">
                      {invoice?.extra_discount}
                    </Typography>
                  </TableCell>
                </RowResultStyle>
                {/* <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="overline">Total Discount</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="overline">$0</Typography>
                  </TableCell>
                </RowResultStyle> */}
                <RowResultStyle>
                  <TableCell colSpan={3} />
                  <TableCell align="center">
                    <Typography variant="subtitle1">Total</Typography>
                  </TableCell>
                  <TableCell align="center" width={10}>
                    <Typography variant="subtitle1">
                      {invoice?.total}
                    </Typography>
                  </TableCell>
                </RowResultStyle>
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>
        {/* </Card>   */}
      </Grid>
    </Stack>
  )
})
